import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CourseCard from '../components/Courses/CourseCard';

const Home = () => {
    const navigate = useNavigate();

    // Função otimizada para direcionar para nosso formulário personalizado
    const openRegistrationForm = (e) => {
        e.preventDefault();
        console.log('Abrindo formulário de inscrição personalizado...');
        navigate('/inscricao');
    };

    const handleWhatsApp = () => {
        window.open('https://api.whatsapp.com/send/?phone=55999968205&text&type=phone_number&app_absent=0', '_blank');
    };

    // Dados dos cursos de formação e qualificação de socorristas
    const featuredCourses = [
        {
            id: 1,
            title: "APH",
            description: "Atendimento Pré Hospitalar. Aprenda técnicas avançadas de primeiros socorros e suporte básico de vida para situações de resgate e emergências.",
            image: "https://images.unsplash.com/photo-1587745416684-47953f16f5ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80"
        },
        {
            id: 2,
            title: "APH-P",
            description: "Atendimento Pré Hospitalar Pediátrico. Especialização em técnicas de primeiros socorros para crianças em situações de resgate.",
            image: "https://images.unsplash.com/photo-1581594549595-35f6edc7b762?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80"
        },
        {
            id: 3,
            title: "APH-T",
            description: "Atendimento Pré Hospitalar Tático. Formação especializada para socorristas que atuam em ambientes hostis e situações de conflito.",
            image: "/apht.jpeg",
            imagePosition: "top"
        },
        {
            id: 6,
            title: "Lei Lucas",
            description: "Capacitação em primeiros socorros para professores e funcionários de escolas, conforme a Lei nº 13.722/2018. Prevenir acidentes é proteger vidas.",
            image: "/leilucas.jpeg",
            imagePosition: "top"
        },
        {
            id: 4,
            title: "SBV",
            description: "Suporte Básico de Vida. Aprenda procedimentos essenciais para socorristas que salvam vidas em situações de emergência cardíaca e respiratória.",
            image: "/sbv.jpeg",
            imagePosition: "center 80%"
        },
        {
            id: 5,
            title: "RCU",
            description: "Resgate em Conflitos Urbanos. Treinamento especializado para socorristas que atuam em situações de resgate em ambientes urbanos complexos.",
            image: "https://images.unsplash.com/photo-1582502744081-2f45c6d2e4cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80"
        }
    ];

    return (
        <div className="flex flex-col min-h-screen">
            {/* Logo Section - Centralizada */}
            <section className="pt-20 pb-6 bg-gradient-to-br from-gray-50 to-orange-50">
                <div className="container mx-auto px-4">
                    <div className="flex justify-center items-center">
                        <a 
                            href="https://www.instagram.com/ecoadventuresm/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="transform hover:scale-105 transition-transform duration-300"
                        >
                            <img 
                                src="/image.png" 
                                alt="EcoAdventure Logo" 
                                className="h-16 md:h-20 lg:h-24 transition-all duration-300 cursor-pointer"
                            />
                        </a>
                    </div>
                </div>
            </section>
            
            {/* Hero Section - Estilo Apple */}
            <section className="pb-16 bg-gradient-to-br from-gray-50 to-orange-50 overflow-hidden">
                <div className="container mx-auto px-4">
                    <div className="flex flex-col items-center text-center mb-16">
                        <span className="text-orange-600 text-sm font-bold tracking-wide uppercase mb-6 bg-orange-100 px-4 py-2 rounded-full">Formação Profissional de Socorristas</span>
                        <h1 className="apple-headline text-gray-900 mb-6 leading-tight">
                            Formação e qualificação<br/>de socorristas desde 2005.
                        </h1>
                        <p className="apple-subheadline mx-auto mb-8">
                            Uma das pioneiras no ramo de treinamentos de APH há 20 anos trazendo conhecimento, educação e inovação para a formação de socorristas.
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button 
                                onClick={openRegistrationForm}
                                className="btn-primary text-center"
                            >
                                Inscreva-se Agora
                            </button>
                            <Link to="/courses" className="btn-outline text-center">
                                Conheça nossos cursos
                            </Link>
                        </div>
                    </div>
                    
                    {/* Imagem Hero - Estilo Apple */}
                    <div className="relative h-[260px] sm:h-[380px] md:h-[500px] rounded-3xl overflow-hidden mx-auto max-w-5xl shadow-2xl ring-1 ring-gray-200">
                        <img 
                            src="/turma.jpeg" 
                            alt="Turma de socorristas formados pela EcoAdventure" 
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
            </section>

            {/* Features Section - Estilo Apple */}
            <section className="py-24 bg-gradient-to-br from-white via-gray-50 to-orange-50 relative overflow-hidden">
                {/* Elementos decorativos de fundo */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-orange-200 rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-96 h-96 bg-red-200 rounded-full blur-3xl opacity-20 translate-y-1/2 -translate-x-1/2"></div>
                
                <div className="container mx-auto px-4 relative z-10">
                    <div className="text-center mb-16">
                        <span className="text-orange-600 text-sm font-bold tracking-wide uppercase mb-3 block bg-white bg-opacity-80 px-4 py-2 rounded-full inline-block shadow-md">Por que nos escolher</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Experiência e tradição</h2>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Fundada em 2005, a Baisch & Oliveira, sob o nome comercial EcoAdventure Cursos e Treinamentos, 
                            é uma das pioneiras no ramo de formação e qualificação de socorristas.
                        </p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                        {/* Feature 1 */}
                        <div className="flex flex-col items-center text-center p-8 rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-400 to-red-500 mb-6 shadow-xl">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">Certificação Reconhecida</h3>
                            <p className="text-gray-600">
                                Nossos certificados são reconhecidos pelas principais instituições de resgate e emergência do país.
                            </p>
                        </div>
                        
                        {/* Feature 2 */}
                        <div className="flex flex-col items-center text-center p-8 rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-400 to-red-500 mb-6 shadow-xl">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">Abordagem Prática</h3>
                            <p className="text-gray-600">
                                Treinamento hands-on com simulações realistas de situações de resgate e emergência.
                            </p>
                        </div>
                        
                        {/* Feature 3 */}
                        <div className="flex flex-col items-center text-center p-8 rounded-2xl bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-orange-400 to-red-500 mb-6 shadow-xl">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <h3 className="text-xl font-bold mb-3 text-gray-900">Instrutores Experientes</h3>
                            <p className="text-gray-600">
                                Equipe de instrutores com experiência real em serviços de resgate e emergência em campo.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cursos Section - Estilo Apple */}
            <section className="py-24 bg-gradient-to-br from-orange-500 via-red-500 to-orange-600 relative overflow-hidden">
                {/* Padrão decorativo de fundo */}
                <div className="absolute inset-0">
                    <div className="absolute top-20 left-20 w-64 h-64 bg-white rounded-full blur-3xl opacity-10"></div>
                    <div className="absolute bottom-20 right-20 w-96 h-96 bg-yellow-300 rounded-full blur-3xl opacity-10"></div>
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-red-600 rounded-full blur-3xl opacity-20"></div>
                </div>
                
                <div className="container mx-auto px-4 relative z-10">
                    <div className="text-center mb-16">
                        <span className="text-white text-sm font-bold tracking-wide uppercase mb-3 block bg-white bg-opacity-20 backdrop-blur-sm px-4 py-2 rounded-full inline-block shadow-lg border border-white border-opacity-30">Nossos Cursos</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 drop-shadow-lg">Formação especializada</h2>
                        <p className="text-xl text-white text-opacity-90 max-w-3xl mx-auto drop-shadow-md">
                            Escolha o programa que melhor atende às suas necessidades de formação e qualificação profissional como socorrista.
                        </p>
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {featuredCourses.map(course => (
                            <CourseCard 
                                key={course.id} 
                                course={course}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Call to Action - Estilo Apple */}
            <section className="py-24 bg-white relative overflow-hidden">
                <div className="container mx-auto px-4 text-center relative z-10">
                    <div className="max-w-4xl mx-auto">
                        <span className="text-orange-600 text-sm font-bold tracking-wide uppercase mb-3 block bg-orange-100 px-4 py-2 rounded-full inline-block shadow-sm">Inscrições Abertas</span>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Comece sua formação hoje</h2>
                        <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10">
                            Inscreva-se em nossos cursos e torne-se um socorrista qualificado. Oferecemos treinamento de alto padrão e certificação reconhecida desde 2005.
                        </p>
                        <button 
                            onClick={openRegistrationForm}
                            className="btn-primary"
                        >
                            Inscreva-se Agora
                        </button>
                    </div>
                </div>
            </section>

            {/* Contato Section - Estilo Apple */}
            <section className="py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
                {/* Padrão decorativo de fundo */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-10 left-10 w-72 h-72 bg-orange-500 rounded-full blur-3xl"></div>
                    <div className="absolute bottom-10 right-10 w-96 h-96 bg-red-500 rounded-full blur-3xl"></div>
                </div>
                
                <div className="container mx-auto px-4 relative z-10">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-16">
                            <span className="text-orange-400 text-sm font-bold tracking-wide uppercase mb-3 block bg-orange-500 bg-opacity-20 px-4 py-2 rounded-full inline-block">Contato</span>
                            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">Entre em contato conosco</h2>
                            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                                Estamos à disposição para esclarecer dúvidas e fornecer mais informações sobre nossos cursos de formação de socorristas.
                            </p>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
                            {/* Contato por Email */}
                            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-10 border border-white border-opacity-20 hover:bg-opacity-20 transition-all hover:scale-105 transform flex flex-col h-full min-h-[280px]">
                                <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mb-6 shadow-lg">
                                    <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold mb-4 text-white">Email</h3>
                                <p className="text-gray-300 mb-6 text-base">Entre em contato por email:</p>
                                <a 
                                    href="mailto:ecoadventuresm@yahoo.com.br" 
                                    className="text-orange-400 hover:text-orange-300 transition-colors font-semibold text-base break-words"
                                >
                                    ecoadventuresm@yahoo.com.br
                                </a>
                            </div>
                            
                            {/* Contato por WhatsApp */}
                            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-10 border border-white border-opacity-20 hover:bg-opacity-20 transition-all hover:scale-105 transform flex flex-col h-full min-h-[280px]">
                                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-6 shadow-lg">
                                    <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold mb-4 text-white">WhatsApp</h3>
                                <p className="text-gray-300 mb-6 text-base">Fale diretamente conosco:</p>
                                <button 
                                    onClick={handleWhatsApp}
                                    className="bg-green-600 text-white font-bold py-3 px-6 rounded-full hover:bg-green-700 transition-all shadow-lg hover:shadow-xl text-base"
                                >
                                    Conversar pelo WhatsApp
                                </button>
                            </div>
                            
                            {/* Contato por Instagram */}
                            <div className="bg-white bg-opacity-10 backdrop-blur-sm rounded-2xl p-10 border border-white border-opacity-20 hover:bg-opacity-20 transition-all hover:scale-105 transform flex flex-col h-full">
                                <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mb-6 shadow-lg">
                                    <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" />
                                    </svg>
                                </div>
                                <h3 className="text-2xl font-bold mb-4 text-white">Instagram</h3>
                                <p className="text-gray-300 mb-6">Siga-nos no Instagram:</p>
                                <a 
                                    href="https://www.instagram.com/ecoadventuresm/" 
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-gradient-to-br from-purple-600 to-pink-600 text-white font-bold py-3 px-6 rounded-full hover:from-purple-700 hover:to-pink-700 transition-all shadow-lg hover:shadow-xl inline-block text-center text-base"
                                >
                                    Visitar Instagram
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;